import notification from 'notification-js';
import Config from 'config';
import Card from 'card';
import Spinner from 'spin';
import moment from 'moment';
import PaymentValid from 'payment';
import AuthDataStorage from "./AuthDataStorage";

export default class Payment {
  constructor() {
    this.authDataStorage = new AuthDataStorage();
    var loggedIn = this.authDataStorage.getLoggedIn();
    if (!loggedIn) {
      window.location.href = "/";
    }
    this.suspended = false;
    this.rewrite = false;
    let queryStrings = window.location.search.substr(1).split("&");
    queryStrings.forEach((queryString) => {
      if (queryString.indexOf("suspended=") === 0) {
        this.suspended = queryString.substr(10) == "true";
      }
      if (queryString.indexOf("rewrite=") === 0) {
        this.rewrite = queryString.substr(8) == "true";
      }
    });

    this.setupPaymentForm();
  }

  setupPaymentForm() {
    this.paymentTypesElement = document.getElementsByClassName('payment-types')[0];
    this.paymentInfoElement = document.getElementsByClassName('payment-info')[0];
    this.licenceInfoElement = document.getElementsByClassName('licence-info')[0];

    this.getLicenceInfo();
  }

  getLicenceInfo() {
    let data = {
      file: './data/buy-now.json'
    };

    var xobj = new XMLHttpRequest();
    xobj.overrideMimeType("application/json");
    xobj.open("POST", Config.BACKEND_URL + '/getpage?t=' + Math.floor(Date.now() / 1000));
    xobj.onreadystatechange = function () {
      if (xobj.readyState == 4 && xobj.status == "200") {
        let licenceInfo = JSON.parse(xobj.response);
        let licences = licenceInfo.sections[0].prices; // get licence for marketing name
        let userData = JSON.parse(this.authDataStorage.getUserData());

        for (var i =0; i< licences.length; i++) {
          if (parseInt(licences[i].licenceId) == parseInt(userData.licencePlanId)) {
            this.licence = licences[i];
            break;
          }
        }

        if (this.licence) {
          this.setupPaymentInfo();
          this.setupLicenceInfo();
          this.setupPaypal();
          this.setupCard();
          this.overlay = document.getElementsByClassName('overlay')[0];
          this.spinner = new Spinner({
            color:'#fff',
            lines: 12,
            top: '50%', // Top position relative to parent
            left: '50%', // Left position relative to parent
            position: 'absolute' // Element positioning
          }).spin(this.overlay);
        }
      }
    }.bind(this);
    xobj.setRequestHeader("Content-Type", "application/json;charset=UTF-8");

    xobj.send(JSON.stringify(data));
  }

  setupLicenceInfo() {
    this.licenceInfoElement.getElementsByClassName('name')[0].innerHTML = this.licence.name;
    let userData = JSON.parse(this.authDataStorage.getUserData());
    let addonsInfo = [];
    if (userData.addonsItems) {
      for (let i=0; i < userData.addonsItems.length; i++) {
        if (userData.addonsItems[i].parentGroupLicenseId == userData.licenceId) {
          addonsInfo.push(userData.addonsItems[i].name + " x" + userData.addonsItems[i].count);
        }
      }
    }

    if (addonsInfo.length > 0) {
      this.licenceInfoElement.innerHTML = this.licenceInfoElement.innerHTML +
              "<br>Additional products: " +  addonsInfo.join(', ');
    }
  }

  setupPaymentInfo() {
    let userData = JSON.parse(this.authDataStorage.getUserData());
    let momentDate = moment(userData.licenceNextRenewal);
    let date = "";

    if (momentDate.isAfter(moment())) {
      date = momentDate.format('MMMM Do YYYY');
    } else {
      date = "today";
    }

    this.paymentInfoElement.getElementsByClassName('date')[0].innerHTML = date;
    this.paymentInfoElement.getElementsByClassName('amount')[0].innerHTML = parseFloat(userData.licenceAmount) + parseFloat(userData.packageAddonsAmount);
  }

  setupPaypal() {
    let button = document.getElementsByClassName('paypal-subscribe')[0];

    button.onclick = function(event) {
      var body = document.body,
          html = document.documentElement;

      var height = Math.max( body.scrollHeight, body.offsetHeight,
                             html.clientHeight, html.scrollHeight, html.offsetHeight );

      var width = Math.max(body.scrollWidth );

      this.overlay.style.display = 'block';
      this.overlay.style.height = height + 'px';
      this.overlay.style.width = width + 'px';

      this.setupSubscription('paypal');
    }.bind(this);
  }

  setupCard() {
    this.card = new Card({
      form: 'form#payment-form',
      container: '.card-wrapper',
      formSelectors: {
        nameInput: 'input[name="first_name"], input[name="last_name"]'
      },
      placeholders: {
        number: '**** **** **** ****',
        name: 'Full Name',
        expiry: 'MM/YYYY',
        cvc: '***'
      }
    });

    let cardSubmit = document.getElementsByClassName('cardsubmit')[0];

    cardSubmit.onclick = function(event) {
      var body = document.body,
          html = document.documentElement;

      var height = Math.max( body.scrollHeight, body.offsetHeight,
                             html.clientHeight, html.scrollHeight, html.offsetHeight );

      var width = Math.max(body.scrollWidth );
      this.overlay.style.display = 'block';
      this.overlay.style.height = height + 'px';
      this.overlay.style.width = width + 'px';
      event.preventDefault();
      this.setupSubscription('credit_card')
    }.bind(this)
  }

  setupSubscription(paymentType) {
    var request = new XMLHttpRequest();

    request.onreadystatechange = function() {
      if (request.readyState == 4) {
        if (request.status !== 200) {
          this.overlay.style.display = 'none';this.overlay.style.display = 'none';
          return this.paymentError('Their was an error dealing with your request please try again.');
        }

        var response = JSON.parse(request.responseText);
        if (!response.success) {
          this.overlay.style.display = 'none';
          return this.paymentError('Invalid payment details');
        }

        if (response.approval_url) {
          window.location.href = response.approval_url;
        } else if (response.redirectToAccount) {
          window.location.href = "/account.html";
        }
      }
    }.bind(this);

    var data = {
      payment: paymentType,
      paymentTerm: 'MONTH',
      licenceName: this.licence.name,
      suspended: this.suspended,
      rewriteAgreement: this.rewrite,
    };

    if (paymentType === 'credit_card') {
      data.card = {};
      data.card.type = this.card.cardType;
      data.card.number = Number(this.card.$numberInput[0].value.replace(/[^\d]/g, ''));

      var firstName = this.paymentTypesElement.getElementsByClassName('first_name')[0];
      var lastName = this.paymentTypesElement.getElementsByClassName('last_name')[0];

      data.card.first_name = firstName.value;
      data.card.last_name = lastName.value;

      data.card.cvv2 = this.card.$cvcInput[0].value;

      var expiry = PaymentValid.fns.cardExpiryVal(this.card.$expiryInput[0].value);

      data.card.expire_month = expiry.month;
      data.card.expire_year = expiry.year;

      if (!this.validateCard(data.card)) {
        return;
      }
    }

    let userData = JSON.parse(this.authDataStorage.getUserData());

    request.open("POST", Config.BACKEND_URL + '/createBillingAgreement');
    request.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
    request.setRequestHeader("auth-token", userData.token);
    request.send(JSON.stringify(data));
  }

  validateCard(card) {
    if (!PaymentValid.fns.validateCardNumber(card.number)) {
      return this.paymentError("Invalid card number");
    }

    if (card.first_name.length == 0) {
      return this.paymentError("Please enter first name");
    }

    if (card.last_name.length == 0) {
      return this.paymentError("Please enter last name");
    }

    if (!PaymentValid.fns.validateCardExpiry(card.expire_month, card.expire_year)) {
      return this.paymentError("Invalid expiry date");
    }

    if (!PaymentValid.fns.validateCardCVC(card.cvv2)) {
      return this.paymentError("Invalid cvc number");
    }

    return true;
  }

  paymentError(message) {
    notification.notify( 'error', message, {
      notification: {position: [ 'right', 'top' ]}
    });
  }
}



// WEBPACK FOOTER //
// ./src/Payment.js